import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const RevenueChart = ({ categories, data, averageRevenue }) => {

  const options = {
    chart: {
      id: "styled-bar",
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true },
      background: "transparent", // No background color
    },
    xaxis: {
      categories: categories || [],
      labels: {
        show: true,
        style: {
          colors: ["#A4A4A4"],
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false, // Removes the bottom horizontal line (x-axis border)
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      show: false, // Removes the horizontal grid lines
    },
    fill: {
      colors: ["#ECECEC"], // Default bar color fill
      opacity: 1,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 12,
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
        fontSize: "10px",
        fontWeight: "bold",
      },
      formatter: function (val) {
        return `${val} SR`;
      },
    },
    annotations: {
      yaxis: [
        {
          y: averageRevenue, // Adjust the average value as needed
          borderColor: "#101010",
          strokeDashArray: [],
          label: {
            borderColor: "#30322C",
            style: {
              color: "#fff",
              background: "#30322C",
            },
            text: `Avg ${averageRevenue}`,
            position: "left",
            offsetX: 40,
          },
        },
      ],
    },
    tooltip: {
      theme: "light",
      enabled: true,
      y: {
        formatter: (val) => `${val} SR bookings`,
      },
    },
    colors: ["#D9D9D9"], // Highlighted color
    states: {
      hover: {
        filter: {
          type: "none", // No filter applied
        },
      },
      active: {
        filter: {
          type: "none", // No filter applied
        },
      },
    },
  };

  const series = [
    {
      name: "Bookings",
      data: data || [],
    },
  ];

  return (
    <div>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default RevenueChart;
